import { copyTextToClipboard } from "../utils/copyTextToClipboard";
import { kInternalOnlyCB } from "../constants";
import { copyTextToClipboardNoEvent } from "../utils/copyTextToClipboardNoEvent.js";

export class QClipboardBuffer {
  constructor() {
    this.fContentType = null;
    this.fContent = null;
  }

  Init(content, contentType, shareableContent) {
    this.fContent = content;
    this.fContentType = contentType;

    if (!shareableContent) {
      //This doesn't really have a purpose- the internal clipboard is a strange concept- we can copy/paste more complicated stuff as needed....
      content = kInternalOnlyCB;
    } else {
      if (!event || !event.clipboardData) copyTextToClipboardNoEvent(content);
      else copyTextToClipboard(content);
    }
  }

  GetContent() {
    return this.fContent;
  }

  GetContentType() {
    return this.fContentType;
  }
}
